import { SITE_URL } from '../config/env.js';
import { isNativeApp } from './platform.js';

export function storyPath(storyId) {
  return `/story/${storyId}`;
}

export function storyUrl(storyId) {
  const base = (SITE_URL || (typeof window !== 'undefined' ? window.location.origin : '')).replace(/\/$/, '');
  return `${base}/story/${storyId}`;
}

export function editionPath(dateKey) {
  return `/edition/${dateKey}`;
}

export function parseAppPath(pathname = '') {
  const path = (pathname || '').replace(/\/$/, '') || '/';
  const storyMatch = path.match(/^\/story\/(\d+)$/);
  if (storyMatch) return { type: 'story', storyId: Number(storyMatch[1]) };
  const editionMatch = path.match(/^\/edition\/(\d{4}-\d{2}-\d{2})$/);
  if (editionMatch) return { type: 'edition', editionDate: editionMatch[1] };
  const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
  const qStory = params.get('story');
  if (qStory) return { type: 'story', storyId: Number(qStory) };
  const qEdition = params.get('edition');
  if (qEdition) return { type: 'edition', editionDate: qEdition };
  return { type: null };
}

export function setStoryUrl(storyId, replace = false) {
  if (typeof window === 'undefined' || isNativeApp()) return;
  const url = storyPath(storyId);
  if (replace) window.history.replaceState({}, '', url);
  else window.history.pushState({}, '', url);
}

export function clearStoryUrl() {
  if (typeof window === 'undefined' || isNativeApp()) return;
  window.history.replaceState({}, '', '/');
}
